















import {Component, Vue} from 'vue-property-decorator';
import {SetupError} from '@/services/api/nswag/stapiclient_generated';
import {UserStore} from '@/store/user-module';

@Component({
    components: {},
  })
  export default class UserSetupError extends Vue {
    getErrorText(setupError: SetupError){
      switch(setupError){
        case SetupError.NoCustomer:
          return this.$t('Ihr Account enthält keinen Kunden oder Sie sind keinem Projekt zugeordnet. Kontaktieren Sie bitte Ihren Administrator oder den SpikeTime Support')
      }
    }

    get setupErrors(){
      return UserStore.userSettings.setupErrors;
    }
  }
